import { render, staticRenderFns } from "./AppVersionConfig.vue?vue&type=template&id=2c83b254&scoped=true"
import script from "./AppVersionConfig.vue?vue&type=script&lang=ts"
export * from "./AppVersionConfig.vue?vue&type=script&lang=ts"
import style0 from "./AppVersionConfig.vue?vue&type=style&index=0&id=2c83b254&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c83b254",
  null
  
)

export default component.exports